import styles from './ServicesContainer.module.scss';

export const ServicesContainer = () => {
    return (
        <div className={styles['services-container']}>
            <div className={styles['black-bg']}>
                <div className={styles['title']} id="services">
                    <div className={styles['card5']}>
                        <p>What I Do</p>
                        <p>Services</p>
                    </div>
                </div>
                <div className={styles['services-column']}>
                    <div className={styles['bottom-row']}>
                        <div className={styles['card1']}>
                            <div className={styles['content-wrapper']}>
                                <p>Licensing & Structuring Advice</p>
                                <div className={styles['body-wrapper']}>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Licensing strategy, structuring considerations, ownership changes and
                                            investor counseling</p>
                                    </div>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>TTB and ABC license applications, updates and transfers</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['card1']}>
                            <div className={styles['content-wrapper']}>
                                <p>Navigating statutory and regulatory changes</p>
                                <div className={styles['body-wrapper']}>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Alcohol cross tier investment, licensing and business relationships
                                            ("tied-house" advice)</p>
                                    </div>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>New laws and regulations</p>
                                    </div>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Route-to-market for imported products, direct-to-consumer (DTC) options, e-commerce models, third party providers, low/no alcohol products, hemp and cannabis beverages</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['card1']}>
                            <div className={styles['content-wrapper']}>
                                <p>Sales & Marketing Compliance</p>
                                <div className={styles['body-wrapper']}>
                                <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Labeling, advertising, marketing, social media, influencer marketing, and brand partnerships</p>
                                    </div>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Sweepstakes, contests, charitable promotions</p>
                                    </div>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Sales and distribution practices, sampling, events, brand ambassadors</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles['bottom-row']}>
                        <div className={styles['card1']}>
                            <div className={styles['content-wrapper']}>
                                <p>Commercial Agreements</p>
                                <div className={styles['body-wrapper']}>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>White label, private/control label, manufacturing/production, IP
                                            licensing</p>
                                    </div>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Alternating proprietorships and alternative production arrangements</p>
                                    </div>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Distribution agreements, brand partnership/influencer agreements</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['card1']}>
                            <div className={styles['content-wrapper']}>
                                <p>Regulatory Investigations & Accusations</p>
                                <div className={styles['body-wrapper']}>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>ABC & TTB investigations, accusations/notices of violation, and audits</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['card1']}>
                            <div className={styles['content-wrapper']}>
                                <p>Mergers & Acquisitions</p>
                                <div className={styles['body-wrapper']}>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Regulatory diligence, asset and stock deal regulatory/license structuring</p>
                                    </div>
                                    <div className={styles['bullet-point-wrapper']}>
                                        <img src="./rectangle.svg" alt="check-icon"/>
                                        <p>Transition services agreements and license transfers / applications</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}